<template>
  <div class="app-main-content">
    <div>
      <el-button type="primary" no="Back" @click="$emit('back')">{{ $t('CargoMsg.Cargo_Back') }}</el-button>
      <span style="margin-left: 15px">{{ $t('CargoMsg.Cargo_CombinationPlanQuery') }}</span>
      <el-checkbox v-model="filter.trunkLineEnable" style="margin-left: 15px" :disabled="active === 1" no="trunkLineEnable">{{ $t('CargoMsg.Cargo_MainlinePrice') }}</el-checkbox>
      <el-checkbox v-model="filter.prePortEnable" :disabled="active === 1 || type ===SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code" no="prePortEnable" @change="prePortEnableChange">{{ $t('CargoMsg.Cargo_PrePortPrice') }}</el-checkbox>
      <el-checkbox v-model="filter.lastMileEnable" :disabled="active === 1" no="lastMileEnable" @change="lastMileEnableChange">{{ $t('CargoMsg.Cargo_LastMilePrice') }}</el-checkbox>
    </div>
    <div>
      <el-steps :active="active" finish-status="success">
        <el-step :title="$t('CargoMsg.Cargo_FillQueryConditions')" />
        <el-step :title="$t('CargoMsg.Cargo_SelectMatchingRate')" />
      </el-steps>
    </div>
    <div>
      <el-button v-if="active === 1" type="primary" no="generateCombinationPlan" @click="generateCombinationPlan">{{ $t('CargoMsg.Cargo_GenerateCombinationPlan') }}</el-button>
    </div>
    <price-combination-step1
      v-if="active === 0"
      :type="type"
      :filter="filter"
    />
    <price-combination-step2
      v-if="active === 1"
      ref="priceCombinationStep2"
      :type="type"
      :trunk-line-enable="filter.trunkLineEnable"
      :pre-port-enable="filter.prePortEnable"
      :last-mile-enable="filter.lastMileEnable"
      :trunk-line-data="trunkLineData"
      :pre-port-data="prePortData"
      :last-mile-data="lastMileData"
      :trunk-line-data-total="trunkLineDataTotal"
      :pre-port-data-total="prePortDataTotal"
      :last-mile-data-total="lastMileDataTotal"
      @pagination="pagination"
    />
    <div style="display: flex;justify-content: center">
      <el-button v-if="active === 0" type="primary" no="next" @click="next">{{ $t('CargoMsg.Cargo_Next') }}</el-button>
      <el-button v-if="active === 1" type="primary" no="backToPreviousStep" @click="backToPreviousStep">{{ $t('CargoMsg.Cargo_ReturnToPreviousStep') }}</el-button>
    </div>
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { InquiryPrice } from '@/class/model/price/InquiryPrice'
import { inquiryDetail, matchPrice, saveAndSubmitInquiryPrice } from '@/api/price/inquiry'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import PriceCombinationStep1 from '@/components/Cargo/Price/priceCombinationStep1'
import PriceCombinationStep2 from '@/components/Cargo/Price/priceCombinationStep2'
import InquiryHp from '@/components/Cargo/Inquiry/InquiryHp'
import { deepClone } from '@/utils'

export default {
  name: 'PriceCombinationStep', // 询价-详情-匹配运价/报价、运价查询-整箱-组合查询
  components: { PriceCombinationStep1, PriceCombinationStep2 },
  props: {
    type: { type: Number, default: SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code } // 运价/询价类型 1-海运整箱、 2-海运拼箱、 3-空运
  },
  data() {
    return {
      SystemConstants,
      filter: new InquiryPrice().fillDefaultValue().getData(),
      active: 0,
      trunkLineData: [],
      prePortData: [],
      lastMileData: [],
      trunkLineDataTotal: 0,
      prePortDataTotal: 0,
      lastMileDataTotal: 0
    }
  },
  methods: {
    pagination(params) {
      const filter = deepClone(this.filter)
      filter.priceTypes = params.priceTypes
      filter.pageNum = params.pageNum
      filter.pageSize = params.pageSize
      this.doMatchPrice(filter)
    },
    next() {
      if (!this.checkBasicInfo()) return
      this.filter.inquiryType = this.type
      this.active++
      const priceTypes = []
      if (this.filter.prePortEnable) {
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code)
      }
      if (this.filter.lastMileEnable) {
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code)
      }
      if (this.filter.trunkLineEnable) {
        priceTypes.push(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code)
      }
      // 1-港前 2-尾程 3-干线
      this.filter.priceTypes = priceTypes
      if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
        this.filter.seaEqTypes = this.filter.seaEqList.filter(p => !!p.type).map(p => p.type).sort()
      } else {
        this.filter.seaEqTypes = []
      }
      // 这个界面没 货好时间， 清空默认值
      this.filter.cargoReadyTimeRange = 0
      // // 这个界面没 中转， 清空默认值
      // this.filter.directTransit = 0
      this.doMatchPrice(this.filter)
    },
    doMatchPrice(filter) {
      matchPrice(filter).then(res => {
        if (this.filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_TRUNK_LINE.code) > -1) {
          if (this.trunkLineData) {
            this.trunkLineData = res.data.trunkLineData.list
            this.trunkLineDataTotal = res.data.trunkLineData.total
          }
        }
        if (this.filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_PRE_PORT.code) > -1) {
          if (this.prePortData) {
            this.prePortData = res.data.prePortData.list
            this.prePortDataTotal = res.data.prePortData.total
          }
        }
        if (this.filter.priceTypes.indexOf(SystemConstants.PRICE_QUOTATION_TYPE_LAST_MILE.code > -1)) {
          if (res.data.lastMileData) {
            this.lastMileData = res.data.lastMileData.list
            this.lastMileDataTotal = res.data.lastMileData.total
          }
        }
      })
    },
    checkBasicInfo() {
      if (!this.filter) return true
      if (!this.filter.trunkLineEnable && !this.filter.prePortEnable && !this.filter.lastMileEnable) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PriceType'))
        return false
      }
      // 航线
      if (!this.filter.commerceCode || this.filter.commerceCode === '') {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Airline'))
        return false
      }
      // 中转港
      if (this.filter.directTransit && this.filter.directTransit === SystemConstants.DIRECT_TRANSIT_TRANSIT.code && !this.filter.transferPortCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.TransitPort'))
        return false
      }
      // 箱型
      if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
        const seaEqList = this.filter.seaEqList
        const uniqueSet = new Set()
        for (const seaEq of seaEqList) {
          if (!seaEq.type || seaEq.type === '') {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ContainerSize'))
            return false
          }
          if (uniqueSet.has(seaEq.type)) {
            this.$message.warning(this.$t('CargoMsg.Cargo_BoxTypeNotAllowedDuplicate'))
            return false
          } else {
            uniqueSet.add(seaEq.type)
          }
        }
      }
      if (this.filter.prePortEnable) {
        if (!this.filter.province) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Province'))
          return false
        }
      }
      if (this.filter.lastMileEnable) {
        if (this.filter.deliveryAddressType === SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code) {
          // 邮编
          if (!this.filter.postalCode) {
            this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SeaExport.ZIP'))
            return false
          }
        }
        if (this.filter.deliveryAddressType !== SystemConstants.DELIVERY_ADDRESS_TYPE_THIRD_PARTY.code && !this.filter.warehouseCode) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_WarehouseCode2'))
          return false
        }
      }
      return true
    },
    backToPreviousStep() {
      this.active = 0
    },
    generateCombinationPlan() {
      let inquiryPrice = new InquiryPrice().fillDefaultValue().getData()
      Object.assign(inquiryPrice, this.filter)
      let prePortPrice
      let lastMilePrice
      let trunkLinePrice
      const priceCombinationResultRef = this.$refs.priceCombinationStep2.$refs.priceCombinationResult
      // 港前
      if (this.filter.prePortEnable) {
        if (!priceCombinationResultRef.prePortData || priceCombinationResultRef.prePortData.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PrePortRate'))
          return
        }
        prePortPrice = priceCombinationResultRef.prePortData.find(p => p.selected === true)
        if (!prePortPrice) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PrePortRate'))
          return
        } else {
          inquiryPrice.prePortPersonUserId = prePortPrice.createdBy
          inquiryPrice.prePortPriceUuid = prePortPrice.uuid
        }
      }
      // 尾程
      if (this.filter.lastMileEnable) {
        if (!priceCombinationResultRef.lastMileData || priceCombinationResultRef.lastMileData.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_EndRouteRate'))
          return
        }
        lastMilePrice = priceCombinationResultRef.lastMileData.find(p => p.selected === true)
        if (!lastMilePrice) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_EndRouteRate'))
          return
        } else {
          inquiryPrice.lastMilePersonUserId = lastMilePrice.createdBy
          inquiryPrice.lastMilePriceUuid = lastMilePrice.uuid
        }
      }
      // 干线
      if (this.filter.trunkLineEnable) {
        if (!priceCombinationResultRef.trunkLineData || priceCombinationResultRef.trunkLineData.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_MainlineRate'))
          return
        }
        trunkLinePrice = priceCombinationResultRef.trunkLineData.find(p => p.selected === true)
        if (!trunkLinePrice) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_MainlineRate'))
          return
        } else {
          inquiryPrice.trunkLinePersonUserId = trunkLinePrice.createdBy
          inquiryPrice.trunkLinePriceUuid = trunkLinePrice.uuid
        }
      }
      inquiryPrice.type = this.type
      if (this.type === SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code) {
        const seaEq = []
        this.filter.seaEqList.forEach(p => {
          seaEq.push(p.quantity + '*' + p.type)
        })
        inquiryPrice.seaEq = seaEq.join(',')
      } else {
        this.filter.seaEqList = []
      }
      this.loading = getLoading4Cxt()
      saveAndSubmitInquiryPrice(inquiryPrice).then(res => {
        inquiryPrice = res.data
        const filter = {
          uuid: inquiryPrice.uuid,
          prePortEnable: inquiryPrice.prePortEnable,
          lastMileEnable: inquiryPrice.lastMileEnable,
          trunkLineEnable: inquiryPrice.trunkLineEnable,
          inquiryType: inquiryPrice.type
        }
        inquiryPrice.seaEqList = this.filter.seaEqList
        inquiryDetail(filter).then(res => {
	          const params = {
	            form: inquiryPrice,
            quotations: res.data.quotations,
	            selectedTrunkLineData: trunkLinePrice && res.data.trunkLineData && res.data.trunkLineData.length > 0 ? res.data.trunkLineData.find(p => p.priceUuid === trunkLinePrice.uuid) : null,
	            selectedPrePortData: prePortPrice && res.data.prePortData && res.data.prePortData.length > 0 ? res.data.prePortData.find(p => p.priceUuid === prePortPrice.uuid) : null,
	            selectedLastMileData: lastMilePrice && res.data.lastMileData && res.data.lastMileData.length > 0 ? res.data.lastMileData.find(p => p.priceUuid === lastMilePrice.uuid) : null
	          }
          const inquiryHp = new InquiryHp(params)
          inquiryHp.remoteBooking(this)
        })
        this.$message.success(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        this.loading.close()
      })
    },
    prePortEnableChange() {
      if (!this.filter.prePortEnable) {
        this.filter.province = ''
        this.filter.city = ''
        this.filter.districts = ''
        this.filter.townUuid = ''
      }
    },
    lastMileEnableChange() {
      if (!this.filter.lastMileEnable) {
        this.filter.postalCode = ''
        this.filter.address = ''
        this.filter.warehouseCode = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
